import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getClinicianProfileBasic } from '../../../../../store/ai2';
import { post } from '../../../../../api/baseUrl';
import type { AppDispatch, RootState } from '../../../../../store';

interface UserPermissionsPayload {
  id: number;
  roles: {
    [key: string]: boolean;
  };
  clinics: {
    [key: number]: boolean;
  };
  userStatus: 0 | 1;
}

export const usePostUpdateUserPermissions = () => {
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { selectedTenancy } = useSelector(
    (state: RootState) => state.clinicianProfile,
  );
  const dispatch = useDispatch<AppDispatch>();

  const postUpdateUserPermissions = async (
    updatePayload: UserPermissionsPayload[],
  ) => {
    if (!selectedTenancy) {
      setErrorMessage('Tenancy not selected');
      return;
    }
    setIsLoading(true);
    try {
      const payload = {
        tenancyId: selectedTenancy.tenancy_id,
        users: updatePayload,
      };
      const { data } = await post(`updateUserPermissions`, {
        ...payload,
      });
      if (data.message === 'Success') {
        dispatch(getClinicianProfileBasic());
      }

      return data.data;
    } catch (error) {
      console.error(
        'An error occurred during patch updateUserPermissions',
        error,
      );
      setErrorMessage(
        // @ts-ignore
        error?.response?.data?.message ||
          'Unknown error in patch updateUserPermissions',
      );
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    postUpdateUserPermissions,
    errorMessage,
    isLoading,
  };
};
